import { render, staticRenderFns } from "./teamTable.vue?vue&type=template&id=4cdc1ebc&scoped=true"
import script from "./teamTable.vue?vue&type=script&lang=js"
export * from "./teamTable.vue?vue&type=script&lang=js"
import style0 from "./teamTable.vue?vue&type=style&index=0&id=4cdc1ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdc1ebc",
  null
  
)

export default component.exports